<template>
  <div class="relative w-full h-full overflow-y-auto">
    <div class="bg-white rounded-lg py-4 pl-4 w-full min-w-fit">
      <span class="font-bold text-xl">Anwesenheitskontrolle</span><br />
      <span class="bg-red-100 bg-yellow-100 hidden">Test</span>
      <select v-model="filter.project" @change="getAttendance()">
        <option value="">Bitte Auswählen</option>
        <option v-for="project in projects" :key="project.id" :value="project.id">
          {{ project.name }}
        </option>
      </select>
      <span class="block text-lg font-bold">Tag</span>
      <input type="date" class="mr-4" v-model="filter.date" @change="getAttendance()" />
      <button v-if="filter.project != ''" @click="getAttendance()">
        Neu Laden
      </button>
    </div>
    <div class="bg-white rounded-lg py-4 pl-4 w-full mt-4 min-w-fit">
      <div class="mb-2">
        <span class="font-bold text-xl">Änderungsanfragen</span>
        <button v-if="filter.project" @click="openAllRequestsModal" class="ml-4 px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600">
          Alle Anfragen anzeigen
        </button>
      </div>
      <span v-if="changeRequests.length == 0" class="font-bold">Keine</span>
      <div v-else>
        Mit einem Klick auf Akzeptieren oder Ablehnen wird eine E-Mail mit dem angegebenen Kommentar an den
        Antragsteller versendet.
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Tag</th>
              <th>Neue Abholzeit</th>
              <th>Wird abgeholt</th>
              <th>Begründung</th>
              <th>Status</th>
              <th>Dokument</th>
              <th>Kommentar (für Aktion)</th>
              <th>Aktionen</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="changeRequest in changeRequests" :key="changeRequest">
              <td class="border border-1">{{ changeRequest.name }}</td>
              <td class="border border-1">{{ changeRequest.day }}</td>
              <td class="border border-1">{{ changeRequest.newTime }}</td>
              <td class="border border-1">{{ changeRequest.pickup ? 'Ja' : 'Nein' }}</td>
              <td class="border border-1">{{ changeRequest.reason }}</td>
              <td class="border border-1">{{ changeRequest.status }}</td>
              <td class="border border-1">
                <a v-if="changeRequest.document" :href="baseOrigin + changeRequest.document" target="_blank" class="text-blue-600 hover:underline">Dokument ansehen</a>
                <span v-else class="text-gray-400">—</span>
              </td>
              <td class="border border-1"><textarea class="bg-gray-50 p-1" v-model="changeRequest.comment"></textarea></td>
              <td class="border border-1">
                <button class="block" @click="handleRequest('accept', changeRequest)">
                  Akzeptieren
                </button>
                <button class="block" @click="handleRequest('decline', changeRequest)">
                  Ablehnen
                </button>
                <button class="block" @click="handleRequest('mail', changeRequest)">
                  E-Mail
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="bg-white rounded-lg py-4 pl-4 mt-4 min-w-fit">
      <span class="font-bold text-lg">Tag-Ausnahme (Schließung/Kommentar)</span>
      <div v-if="adeLoading" class="text-gray-400">Lade...</div>
      <div v-else>
        <div v-if="attendanceDayException && !adeEdit">
          <input type="checkbox" class="small" v-model="adeForm.closed" disabled id="adeClosed" />
          <label for="adeClosed">Geschlossen</label>
          <span class="ml-4">Kommentar: <span class="italic">{{ attendanceDayException.comment || '—' }}</span></span>
          <button class="ml-4 px-2 py-1 bg-yellow-200 rounded" @click="startEditADE">Bearbeiten</button>
          <button class="ml-2 px-2 py-1 bg-red-200 rounded" @click="deleteAttendanceDayException">Löschen</button>
        </div>
        <div v-else>
          <input type="checkbox" class="small" v-model="adeForm.closed" id="adeClosed" />
          <label for="adeClosed">Geschlossen</label>
          <input class="border px-2 py-1 mr-2" v-model="adeForm.comment" placeholder="Kommentar"
            style="min-width:180px" />
          <button class="px-2 py-1 rounded" @click="saveAttendanceDayException">Speichern</button>
          <button v-if="attendanceDayException" class="ml-2 px-2 py-1 rounded" @click="cancelEditADE">Abbrechen</button>
        </div>
        <div v-if="adeError" class="text-red-500 mt-1">{{ adeError }}</div>
      </div>
    </div>
    <div class="bg-white rounded-lg py-4 pl-4 w-full mt-4">
      <div class="flex flex-wrap items-center justify-between gap-2 mb-3">
        <span class="font-bold text-xl">Shortcuts</span>
        <div class="flex items-center gap-2 flex-wrap relative">
          <button class="px-3 py-2 border rounded relative" @click="toggleColumnsOpen = !toggleColumnsOpen">
            Spalten
            <span
              class="ml-2 inline-flex items-center justify-center text-xs font-semibold rounded-full bg-gray-200 px-2 py-0.5">
              {{ visibleCount }}
            </span>
          </button>
          <div v-if="toggleColumnsOpen"
            class="fixed right-4 top-24 bg-white border rounded shadow p-3 z-[9999] max-h-80 w-72 overflow-auto"
            ref="columnsDropdown">
            <div class="flex justify-between items-center mb-2">
              <div class="font-semibold">Sichtbare Spalten</div>
              <button @click="toggleColumnsOpen = false"
                class="text-gray-500 hover:text-gray-700 text-xl leading-none">&times;
              </button>
            </div>
            <div class="mb-2">
              <input v-model="columnFilter" type="text" placeholder="Spalten filtern..."
                class="w-full border rounded px-2 py-1 text-sm" @click.stop />
            </div>
            <div class="max-h-48 overflow-y-auto">
              <div v-for="col in filteredColumns" :key="col.key" class="py-1">
                <label class="flex items-center gap-2 cursor-pointer select-none px-2 py-1 rounded"
                  :class="visible[col.key] ? 'bg-green-50 text-green-800' : 'hover:bg-gray-50'" :for="`col-${col.key}`">
                  <input :id="`col-${col.key}`" type="checkbox" :checked="visible[col.key]"
                    @change="toggleColumn(col.key, $event.target.checked)" />
                  <span class="truncate">{{ col.label }}</span>
                  <span v-if="visible[col.key]" class="ml-auto w-2 h-2 rounded-full bg-green-500"></span>
                </label>
              </div>
              <div v-if="filteredColumns.length === 0" class="text-gray-500 text-sm text-center py-2">
                Keine Spalten gefunden
              </div>
            </div>
            <div class="flex gap-2 mt-2 pt-2 border-t">
              <button class="px-2 py-1 border rounded text-sm" @click="showAllCols(true)">Alle</button>
              <button class="px-2 py-1 border rounded text-sm" @click="showAllCols(false)">Keine</button>
              <button class="px-2 py-1 border rounded text-sm" @click="resetCols()">Zurücksetzen</button>
            </div>
          </div>
        </div>
      </div>
      <button class="mr-2 mt-2" @click="checkout15Min()">
        Kinder mit Gehzeit +-15 min abmelden
      </button>
      <button class="mr-2 mt-2" @click="checkVisible(true)">
        Alle angezeigten anmelden
      </button>
      <button class="mr-2 mt-2" @click="checkVisible(false)">
        Alle angezeigten abmelden
      </button>
    </div>

    <div class="bg-white rounded-lg py-4 pl-4 mt-4 min-w-fit" v-if="contracts.length > 0">
      <span class="font-bold text-lg">Angezeigte Verträge: {{filteredContracts.length }}</span>
      <table class="w-full">
        <thead class="sticky top-0 bg-white z-10">
          <tr>
            <th v-if="visible.firstname" class="border-b border-gray-300 p-2 bg-gray-50">
              <div class="flex items-center justify-between">
                <span>Vorname</span>
                <button @click="toggleSort('firstname')" class="text-gray-400 hover:text-primary ml-1">
                  <font-awesome-icon :icon="getSortIcon('firstname')" />
                </button>
              </div>
            </th>
            <th v-if="visible.lastname" class="border-b border-gray-300 p-2 bg-gray-50">
              <div class="flex items-center justify-between">
                <span>Nachname</span>
                <button @click="toggleSort('lastname')" class="text-gray-400 hover:text-primary ml-1">
                  <font-awesome-icon :icon="getSortIcon('lastname')" />
                </button>
              </div>
            </th>
            <th v-if="visible.class" class="border-b border-gray-300 p-2 bg-gray-50">
              <div class="flex items-center justify-between">
                <span>Klasse</span>
                <div class="flex items-center gap-1">
                  <button @click="toggleSort('class')" class="text-gray-400 hover:text-primary">
                    <font-awesome-icon :icon="getSortIcon('class')" />
                  </button>
                  <button :class="classEdit?'bg-red-400':''" @click="classEdit = !classEdit"><font-awesome-icon icon="pen" /></button>
                </div>
              </div>
            </th>
            <th v-if="visible.expected" class="border-b border-gray-300 p-2 bg-gray-50">
              <div class="flex items-center justify-between">
                <span>Erwartet</span>
                <button @click="toggleSort('expected')" class="text-gray-400 hover:text-primary ml-1">
                  <font-awesome-icon :icon="getSortIcon('expected')" />
                </button>
              </div>
            </th>
            <th v-if="visible.plannedEnd" class="border-b border-gray-300 p-2 bg-gray-50">
              <div class="flex items-center justify-between">
                <span>Geht um</span>
                <button @click="toggleSort('plannedEnd')" class="text-gray-400 hover:text-primary ml-1">
                  <font-awesome-icon :icon="getSortIcon('plannedEnd')" />
                </button>
              </div>
            </th>
            <th v-if="visible.pickup" class="border-b border-gray-300 p-2 bg-gray-50">
              <div class="flex items-center justify-between">
                <span>Wird abgeholt</span>
                <button @click="toggleSort('pickup')" class="text-gray-400 hover:text-primary ml-1">
                  <font-awesome-icon :icon="getSortIcon('pickup')" />
                </button>
              </div>
            </th>
            <th v-if="visible.started" class="border-b border-gray-300 p-2 bg-gray-50">
              <div class="flex items-center justify-between">
                <span>Angemeldet</span>
                <button @click="toggleSort('started')" class="text-gray-400 hover:text-primary ml-1">
                  <font-awesome-icon :icon="getSortIcon('started')" />
                </button>
              </div>
            </th>
            <th v-if="visible.ended" class="border-b border-gray-300 p-2 bg-gray-50">
              <div class="flex items-center justify-between">
                <span>Abgemeldet</span>
                <button @click="toggleSort('ended')" class="text-gray-400 hover:text-primary ml-1">
                  <font-awesome-icon :icon="getSortIcon('ended')" />
                </button>
              </div>
            </th>
            <th v-if="visible.excused" class="border-b border-gray-300 p-2 bg-gray-50">
              <div class="flex items-center justify-between">
                <span>Entschuldigt</span>
                <button @click="toggleSort('excused')" class="text-gray-400 hover:text-primary ml-1">
                  <font-awesome-icon :icon="getSortIcon('excused')" />
                </button>
              </div>
            </th>
            <th v-if="visible.sick" class="border-b border-gray-300 p-2 bg-gray-50">
              <div class="flex items-center justify-between">
                <span>Krank</span>
                <button @click="toggleSort('sick')" class="text-gray-400 hover:text-primary ml-1">
                  <font-awesome-icon :icon="getSortIcon('sick')" />
                </button>
              </div>
            </th>
            <th v-if="visible.comment" class="border-b border-gray-300 p-2 bg-gray-50">
              <div class="flex items-center justify-between">
                <span>Kommentar</span>
                <button @click="toggleSort('comment')" class="text-gray-400 hover:text-primary ml-1">
                  <font-awesome-icon :icon="getSortIcon('comment')" />
                </button>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td v-if="visible.firstname">
              <input class="border-2 border-gray-200 px-2 py-1" v-model="filter.firstname" type="text" placeholder="Filter"
                @input="filterContracts()" />
            </td>
            <td v-if="visible.lastname">
              <input class="border-2 border-gray-200 px-2 py-1" v-model="filter.lastname" type="text" placeholder="Filter"
                @input="filterContracts()" />
            </td>
            <td v-if="visible.class" class="relative">
              <button @click="toggleClassFilter" class="border-2 border-gray-200 px-2 py-1 w-full text-left bg-white">
                <span v-if="selectedClasses.length === 0">Filter</span>
                <span v-else-if="selectedClasses.length === uniqueClasses.length">Alle</span>
                <span v-else>{{ selectedClasses.length }} ausgewählt</span>
              </button>
              <div v-if="classFilterOpen" class="absolute left-0 top-full mt-1 bg-white border rounded shadow-lg z-[9999] w-48 max-h-64 overflow-auto" ref="classFilterDropdown">
                <div class="p-2 border-b flex gap-2">
                  <button @click="selectAllClasses" class="px-2 py-1 text-xs border rounded hover:bg-gray-100">Alle</button>
                  <button @click="selectNoClasses" class="px-2 py-1 text-xs border rounded hover:bg-gray-100">Keine</button>
                </div>
                <div class="p-2">
                  <label v-for="klasse in uniqueClasses" :key="klasse" class="flex items-center gap-2 py-1 cursor-pointer hover:bg-gray-50 px-1 rounded" :class="{'bg-blue-100': selectedClasses.includes(klasse)}">
                    <input type="checkbox" :value="klasse" v-model="selectedClasses" @change="filterContracts()" />
                    <span :class="{'font-semibold text-blue-700': selectedClasses.includes(klasse)}">{{ klasse }}</span>
                  </label>
                </div>
              </div>
            </td>
            <td v-if="visible.expected">
              <select v-model="filter.attendance.expected" @change="filterContracts()">
                <option value="">Filter</option>
                <option value="true">Ja</option>
                <option value="false">Nein</option>
              </select>
            </td>
            <td v-if="visible.plannedEnd">
              <input type="time" class="w-36 border-b border-gray-300 bg-inherit" v-model="filter.attendance.plannedEnd"
                @input="filterContracts()" />
            </td>
            <td v-if="visible.pickup">
              <select v-model="filter.pickup" @change="filterContracts()">
                <option value="">Filter</option>
                <option value="true">Ja</option>
                <option value="false">Nein</option>
              </select>
            </td>
            <td v-if="visible.started">
              <select v-model="filter.attendance.started" @change="filterContracts()">
                <option value="">Filter</option>
                <option value="true">Ja</option>
                <option value="false">Nein</option>
              </select>
            </td>
            <td v-if="visible.ended">
              <select v-model="filter.attendance.ended" @change="filterContracts()">
                <option value="">Filter</option>
                <option value="true">Ja</option>
                <option value="false">Nein</option>
              </select>
            </td>
            <td v-if="visible.excused">
              <select v-model="filter.attendance.excused" @change="filterContracts()">
                <option value="">Filter</option>
                <option value="true">Ja</option>
                <option value="false">Nein</option>
              </select>
            </td>
            <td v-if="visible.sick">
              <select v-model="filter.attendance.sick" @change="filterContracts()">
                <option value="">Filter</option>
                <option value="true">Ja</option>
                <option value="false">Nein</option>
              </select>
            </td>
            <td v-if="visible.comment">
              <input class="border-2 border-gray-200 px-2 py-1" v-model="filter.attendance.comment" type="text"
                placeholder="Filter" @input="filterContracts()" />
            </td>
          </tr>
          <tr v-for="contract in sortedContracts" :key="contract.id"
            :class="[shouldBeHighlighted(contract.attendance)]">
            <td v-if="visible.firstname" class="font-bold">{{ contract.firstname }}</td>
            <td v-if="visible.lastname" class="font-bold">{{ contract.lastname }}</td>
            <td v-if="visible.class">
              <div v-if="classEdit">
                <input type="text" v-model="contract.class" class="w-full"
                  @input="showChangeClassButton = contract.id" />
                <div v-if="showChangeClassButton == contract.id" class="w-full text-center">
                  <button @click="changeClass(contract)">Speichern</button>
                </div>
              </div>
              <span v-else>{{ contract.class }}</span>
            </td>
            <td v-if="visible.expected" class="!text-center">
              <input :id="'chkatt_' + contract.id" type="checkbox" class="inline-block smaller"
                v-model="contract.attendance.expected" @change="setAttendance(contract)" />
              <label :for="'chkatt_' + contract.id"></label>
            </td>
            <td v-if="visible.plannedEnd">
              <div v-if="contract.attendance.plannedEndChanged">
                <span class="p-1 text-green-600 font-bold text-sm">Geändert</span><br>
              </div>
              <input type="time" class="w-36 border-b border-gray-300 bg-inherit"
                v-model="contract.attendance.plannedEnd" @change="setAttendance(contract)" />
            </td>
            <td v-if="visible.pickup" class="!text-center">
              <span v-if="contract.attendance.pickup" class="p-1 bg-red-500 font-bold rounded-lg">Ja</span>
              <span v-else>Nein</span>
            </td>
            <td v-if="visible.started" class="!text-center">
              <div v-if="!contract.attendance.sick && !contract.attendance.excused">
                <input :id="'chkattst_' + contract.id" type="checkbox" class="inline-block smaller"
                  v-model="contract.attendance.started" @change="setAttendance(contract)" />
                <label :for="'chkattst_' + contract.id"><span class="align-top" v-if="contract.attendance.startTime">
                    ({{ contract.attendance.startTime }})</span></label>
              </div>
            </td>
            <td v-if="visible.ended" class="!text-center">
              <div v-if="!contract.attendance.sick && !contract.attendance.excused">
                <input :id="'chkattend_' + contract.id" type="checkbox" class="inline-block smaller"
                  v-model="contract.attendance.ended" @change="setAttendance(contract)" />
                <label :for="'chkattend_' + contract.id"><span class="align-top" v-if="contract.attendance.endTime"> ({{
                  contract.attendance.endTime }})</span></label>
              </div>
            </td>
            <td v-if="visible.excused" class="!text-center">
              <div v-if="!contract.attendance.started">
                <input :id="'chkattex_' + contract.id" type="checkbox" class="inline-block smaller"
                  v-model="contract.attendance.excused" @change="setAttendance(contract)" />
                <label :for="'chkattex_' + contract.id"></label>
              </div>
            </td>
            <td v-if="visible.sick" class="!text-center">
              <div v-if="!contract.attendance.started">
                <input :id="'chkattsick_' + contract.id" type="checkbox" class="inline-block smaller"
                  v-model="contract.attendance.sick" @change="setAttendance(contract)" />
                <label :for="'chkattsick_' + contract.id"></label>
              </div>
            </td>
            <td v-if="visible.comment">
              <input class="w-full border-b border-gray-300 bg-inherit" v-model="contract.attendance.comment"
                @change="setAttendance(contract)" />
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="filteredContracts.length == 0" class="w-full text-center">
        <span class="font-bold inline-block">Keine Einträge für diesen Filter</span><br />
      </div>
    </div>
    <div v-else-if="filter.project" class="bg-white rounded-lg py-4 text-center pl-4 w-full mt-4">
      <span class="font-bold text-xl inline-block">Keine Verträge gefunden</span><br />
    </div>
    <div v-else class="bg-white rounded-lg py-4 text-center pl-4 w-full mt-4">
      <span class="font-bold text-xl inline-block">Bitte Projekt auswählen</span><br />
    </div>

    <!-- All Requests Modal -->
    <div v-if="showAllRequestsModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" @click.self="closeAllRequestsModal">
      <div class="bg-white rounded-lg p-6 max-w-10xl w-full max-h-[90vh] overflow-y-auto">
        <div class="flex justify-between items-center mb-4">
          <h2 class="text-2xl font-bold">Alle Änderungsanfragen</h2>
          <button @click="closeAllRequestsModal" class="text-gray-500 hover:text-gray-700 text-2xl">&times;</button>
        </div>
        <div v-if="loadingAllRequests" class="text-center py-8">
          <span class="text-gray-500">Lade...</span>
        </div>
        <div v-else-if="allRequests.length == 0" class="text-center py-8">
          <span class="font-bold">Keine Anfragen gefunden</span>
        </div>
        <table v-else class="w-full">
          <thead>
            <tr>
              <th class="border border-gray-300 p-2 bg-gray-50">ID</th>
              <th class="border border-gray-300 p-2 bg-gray-50">Name</th>
              <th class="border border-gray-300 p-2 bg-gray-50">Tag</th>
              <th class="border border-gray-300 p-2 bg-gray-50">Art</th>
              <th class="border border-gray-300 p-2 bg-gray-50">Neue Zeit</th>
              <th class="border border-gray-300 p-2 bg-gray-50">Wird abgeholt</th>
              <th class="border border-gray-300 p-2 bg-gray-50">Begründung</th>
              <th class="border border-gray-300 p-2 bg-gray-50">Status</th>
              <th class="border border-gray-300 p-2 bg-gray-50">Dokument</th>
              <th class="border border-gray-300 p-2 bg-gray-50">Kommentar</th>
              <th class="border border-gray-300 p-2 bg-gray-50">Erstellt am</th>
              <th class="border border-gray-300 p-2 bg-gray-50">Beantwortet am</th>
              <th class="border border-gray-300 p-2 bg-gray-50">Beantwortet von</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="request in allRequests" :key="request.id">
              <td class="border border-gray-300 p-2">{{ request.id }}</td>
              <td class="border border-gray-300 p-2">{{ request.name }}</td>
              <td class="border border-gray-300 p-2">{{ request.day }}</td>
              <td class="border border-gray-300 p-2">{{ request.kind }}</td>
              <td class="border border-gray-300 p-2">{{ request.newTime }}</td>
              <td class="border border-gray-300 p-2">{{ request.pickup ? 'Ja' : 'Nein' }}</td>
              <td class="border border-gray-300 p-2">{{ request.reason }}</td>
              <td class="border border-gray-300 p-2">
                <span :class="{
                  'bg-yellow-200 px-2 py-1 rounded': request.status === 'Eingegangen',
                  'bg-green-200 px-2 py-1 rounded': request.status === 'Bestätigt',
                  'bg-red-200 px-2 py-1 rounded': request.status === 'Abgelehnt'
                }">{{ request.status }}</span>
              </td>
              <td class="border border-gray-300 p-2">
                <a v-if="request.document" :href="baseOrigin + request.document" target="_blank" class="text-blue-600 hover:underline">Dokument ansehen</a>
                <span v-else class="text-gray-400">—</span>
              </td>
              <td class="border border-gray-300 p-2">{{ request.comment || '-' }}</td>
              <td class="border border-gray-300 p-2">{{ request.createdAt }}</td>
              <td class="border border-gray-300 p-2">{{ request.respondedAt || '-' }}</td>
              <td class="border border-gray-300 p-2">{{ request.respondedBy || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style scoped>
table {
  max-width: 100%;
  border-collapse: collapse;
}

label {
  margin-top: 0px;
  font-weight: normal;
  align-items: center;
}

th,
td {
  text-align: left;
  border-bottom: 1px solid #ddd;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
  /* Set the background color for even rows */
}
</style>

<script>
// @ is an alias to /src
import API from "@/API";
import Fuse from 'fuse.js';

export default {
  name: "Attendance",

  data() {
    return {
      showChangeClassButton: 0,
      classEdit: false,
      changeRequests: [],
      allRequests: [],
      showAllRequestsModal: false,
      loadingAllRequests: false,
      projects: [],
      selectedClasses: [],
      classFilterOpen: false,
      filter: {
        project: "",
        date: "",
        firstname: "",
        lastname: "",
        pickup: "",
        attendance: {
          plannedEnd: "",
          expected: "",
          started: "",
          ended: "",
          excused: "",
          sick: "",
          comment: "",
        },
      },
      contracts: [],
      filteredContracts: [],
      attendanceDayException: null,
      adeForm: { closed: false, comment: "" },
      adeEdit: false,
      adeLoading: false,
      adeError: "",
      // Column visibility controls
      columns: [
        { key: 'firstname', label: 'Vorname' },
        { key: 'lastname', label: 'Nachname' },
        { key: 'class', label: 'Klasse' },
        { key: 'expected', label: 'Erwartet' },
        { key: 'plannedEnd', label: 'Geht um' },
        { key: 'pickup', label: 'Wird abgeholt' },
        { key: 'started', label: 'Angemeldet' },
        { key: 'ended', label: 'Abgemeldet' },
        { key: 'excused', label: 'Entschuldigt' },
        { key: 'sick', label: 'Krank' },
        { key: 'comment', label: 'Kommentar' }
      ],
      defaultVisible: {
        firstname: true,
        lastname: true,
        class: true,
        expected: true,
        plannedEnd: true,
        pickup: true,
        started: true,
        ended: true,
        excused: true,
        sick: true,
        comment: true
      },
      visible: {},
      toggleColumnsOpen: false,
      columnFilter: '',
      sort_by: 'firstname',
      sort_order: 'asc'
    };
  },
  methods: {
    checkout15Min() {
      const thresholdInMilliseconds = 15 * 60 * 1000; // 15 minutes in milliseconds
      this.contracts.forEach((contract) => {
        if (contract.attendance.expected && contract.attendance.started) {
          const today = new Date();
          const plannedEndTime = contract.attendance.plannedEnd.split(":");
          const plannedEndDate = new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDate(),
            plannedEndTime[0],
            plannedEndTime[1]
          );
          if (
            Math.abs(plannedEndDate.getTime() - today.getTime()) <
            thresholdInMilliseconds
          ) {
            contract.attendance.ended = true;
            this.setAttendance(contract);
          }
        }
      });
    },
    handleRequest(action, request) {
      if (action == "mail") {
        window.open(
          "mailto:" +
          request.mail +
          "?subject=Änderung der Abholzeit auf " +
          request.newTime +
          "&body="
        );
      } else if (action == "accept") {
        API.acceptRequest(request, (r, status) => {
          this.getChangeRequests();
          this.getAttendance();
        });
      } else if (action == "decline") {
        API.declineRequest(request, (r, status) => {
          this.getChangeRequests();
          this.getAttendance();
        });
      }
    },
    checkVisible(checkin) {
      this.filteredContracts.forEach((contract) => {
        if (contract.attendance.sick || contract.attendance.excused) {
          return;
        }
        if (checkin) {
          contract.attendance.started = true;
        } else if (contract.attendance.started) {
          contract.attendance.ended = true;
        }
        this.setAttendance(contract);
      });
    },
    getChangeRequests() {
      API.getChangeRequests(this.filter.project, (r, status) => {
        this.changeRequests = r;
      });
    },
    openAllRequestsModal() {
      this.showAllRequestsModal = true;
      this.loadingAllRequests = true;
      API.getAllChangeRequests(this.filter.project, (r, status) => {
        this.loadingAllRequests = false;
        if (status === 200) {
          this.allRequests = r;
        }
      });
    },
    closeAllRequestsModal() {
      this.showAllRequestsModal = false;
      this.allRequests = [];
    },
    shouldBeHighlighted(attendance) {
      if (attendance.ended || attendance.excused || !attendance.expected || attendance.sick) {
        return '';
      }
      if (attendance.expected && !attendance.started) {
        return '!bg-red-100'
      }
      if (attendance.expected) {
        const plannedEndTime = attendance.plannedEnd.split(":");
        const now = new Date();
        const plannedEndDate = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          plannedEndTime[0],
          plannedEndTime[1]
        );
        const timeDifference = plannedEndDate.getTime() - now.getTime();
        console.log(timeDifference)
        if (timeDifference < 15 * 60 * 1000 && timeDifference > 0) {
          return '!bg-yellow-100';
        } else if (timeDifference < 0) {
          return '!bg-red-100';
        }
      }
      if (attendance.started) {
        return '!bg-green-100'
      }
      return '';
    },
    changeClass(contract) {
      API.changeClassOfContract(contract.id, contract.class, (r, status) => {
        this.showChangeClassButton = 0;
      });
    },
    setAttendance(contract) {
      let vm = this;
      API.setAttendance(
        {
          id: contract.id,
          attendance: contract.attendance,
        },
        (r, status) => {
          Object.keys(r).forEach((key) => {
            contract.attendance[key] = r[key];
          });
        }
      );
    },
    getProjects() {
      let vm = this;
      API.getPickupProjects((r, status) => {
        if (status === 200) {
          vm.projects = r;
        }
      });
    },
    filterContracts() {
      let vm = this;
      let fuse = new Fuse(this.contracts, {
        keys: ["firstname"],
        threshold: 0.4,
      });
      console.log("filtering with ",this.filter.firstname)
      if (this.filter.firstname != "") {
        this.filteredContracts = fuse.search(this.filter.firstname).map((item) => item.item);
        if (this.filteredContracts.length == 0) {
          return []
        }
      } else {
        this.filteredContracts = this.contracts;
      }
      fuse = new Fuse(this.filteredContracts, {
        keys: ["lastname"],
        threshold: 0.4,
      });
      if (this.filter.lastname != "") {
        this.filteredContracts = fuse.search(this.filter.lastname).map((item) => item.item);
        if (this.filteredContracts.length == 0) {
          return []
        }
      }
      this.filteredContracts = this.filteredContracts.filter((item) => {
        if (this.selectedClasses.length > 0 && !this.selectedClasses.includes(item.class)) {
          return false;
        }
        if (
          item.attendance.comment.toLowerCase().indexOf(vm.filter.attendance.comment.trim().toLowerCase()) < 0
        ) {
          return false;
        }
        if (item.attendance.plannedEnd && item.attendance.plannedEnd.indexOf(vm.filter.attendance.plannedEnd) < 0) {
          return false;
        }
        if (
          vm.filter.attendance.expected == "true" &&
          !item.attendance.expected
        )
          return false;
        if (vm.filter.pickup == "true" && !item.pickup)
          return false;
        if (vm.filter.pickup == "false" && item.pickup)
          return false;
        if (vm.filter.attendance.sick == "true" && !item.attendance.sick)
          return false;
        if (vm.filter.attendance.sick == "false" && item.attendance.sick)
          return false;
        if (vm.filter.attendance.ended == "true" && !item.attendance.ended)
          return false;
        if (vm.filter.attendance.started == "true" && !item.attendance.started)
          return false;
        if (vm.filter.attendance.excused == "true" && !item.attendance.excused)
          return false;
        if (vm.filter.attendance.ended == "true" && !item.attendance.ended)
          return false;
        if (vm.filter.attendance.ended == "false" && item.attendance.ended)
          return false;
        if (vm.filter.attendance.started == "false" && item.attendance.started)
          return false;
        if (vm.filter.attendance.excused == "false" && item.attendance.excused)
          return false;
        if (vm.filter.attendance.ended == "false" && item.attendance.ended)
          return false;
        if (
          vm.filter.attendance.expected == "false" &&
          item.attendance.expected
        )
          return false;
        return true;
      });
    },

    getAttendance() {
      let vm = this;
      this.updateUrl();
      this.getChangeRequests();
      this.loadAttendanceDayException();
      API.getAttendance(vm.filter.project, vm.filter.date, (r, status) => {
        if (status === 200) {
          vm.contracts = r;
          setTimeout(() => {
            vm.filterContracts();
          }, 50);
        }
      });
    },
    loadAttendanceDayException() {
      this.adeLoading = true;
      this.adeError = "";
      this.attendanceDayException = null;
      this.adeEdit = false;
      this.adeForm = { closed: false, comment: "" };
      if (!this.filter.project || !this.filter.date) {
        this.adeLoading = false;
        return;
      }
      API.getAttendanceDayException(this.filter.project, this.filter.date, (r, status) => {
        this.adeLoading = false;
        if (status === 200 && r && (r.id || r.closed !== undefined || r.comment !== undefined)) {
          this.attendanceDayException = r;
          this.adeForm = { closed: !!r.closed, comment: r.comment || "" };
        } else {
          this.attendanceDayException = null;
          this.adeForm = { closed: false, comment: "" };
        }
      });
    },
    saveAttendanceDayException() {
      this.adeError = "";
      const payload = {
        project: this.filter.project,
        date: this.filter.date,
        closed: this.adeForm.closed,
        comment: this.adeForm.comment
      };
      if (this.attendanceDayException && this.attendanceDayException.id) {
        API.updateAttendanceDayException(this.attendanceDayException.id, payload, (r, status) => {
          if (status === 200) {
            this.adeEdit = false;
            this.loadAttendanceDayException();
          } else {
            this.adeError = "Fehler beim Speichern.";
          }
        });
      } else {
        API.createAttendanceDayException(payload, (r, status) => {
          if (status === 200) {
            this.adeEdit = false;
            this.loadAttendanceDayException();
          } else {
            this.adeError = "Fehler beim Anlegen.";
          }
        });
      }
    },
    deleteAttendanceDayException() {
      if (!this.attendanceDayException || !this.attendanceDayException.id) return;
      if (!confirm('Wirklich löschen?')) return;
      API.deleteAttendanceDayException(this.attendanceDayException.id, (r, status) => {
        if (status === 200) {
          this.attendanceDayException = null;
          this.adeForm = { closed: false, comment: "" };
          this.adeEdit = false;
        } else {
          this.adeError = "Fehler beim Löschen.";
        }
      });
    },
    startEditADE() {
      this.adeEdit = true;
      this.adeForm = { closed: !!this.attendanceDayException.closed, comment: this.attendanceDayException.comment || "" };
    },
    cancelEditADE() {
      this.adeEdit = false;
      this.adeForm = { closed: !!(this.attendanceDayException && this.attendanceDayException.closed), comment: (this.attendanceDayException && this.attendanceDayException.comment) || "" };
    },
    updateUrl() {
      this.$router.push({
        query: {
          ...this.$route.query,
          date: this.filter.date,
          project: this.filter.project,
        },
      });
    },
    // Column visibility methods
    initColumnVisibility() {
      // Try to load visibility from localStorage
      const persisted = localStorage.getItem(this.visibilityKey);
      let persistedObj = null;
      try {
        persistedObj = persisted ? JSON.parse(persisted) : null;
      } catch (e) {
        persistedObj = null;
      }

      // Set visibility for each column
      this.columns.forEach(col => {
        this.visible[col.key] = (persistedObj && col.key in persistedObj)
          ? persistedObj[col.key]
          : this.defaultVisible[col.key];
      });
    },
    persistVisibility() {
      localStorage.setItem(this.visibilityKey, JSON.stringify(this.visible));
    },
    toggleColumn(key, val) {
      this.visible[key] = val;
      this.persistVisibility();
    },
    showAllCols(v) {
      Object.keys(this.visible).forEach(k => this.visible[k] = v);
      this.persistVisibility();
    },
    resetCols() {
      Object.entries(this.defaultVisible).forEach(([k, v]) => this.visible[k] = v);
      this.persistVisibility();
    },
    handleClickOutside(event) {
      if (this.toggleColumnsOpen && this.$refs.columnsDropdown && !this.$refs.columnsDropdown.contains(event.target)) {
        // Check if click is not on the Spalten button itself
        const spaltenButton = event.target.closest('button');
        if (!spaltenButton || !spaltenButton.textContent.includes('Spalten')) {
          this.toggleColumnsOpen = false;
        }
      }
    },
    handleEscapeKey(event) {
      if (event.key === 'Escape' && this.toggleColumnsOpen) {
        this.toggleColumnsOpen = false;
      }
      if (event.key === 'Escape' && this.classFilterOpen) {
        this.classFilterOpen = false;
      }
    },
    toggleClassFilter() {
      this.classFilterOpen = !this.classFilterOpen;
    },
    selectAllClasses() {
      this.selectedClasses = [...this.uniqueClasses];
      this.filterContracts();
    },
    selectNoClasses() {
      this.selectedClasses = [];
      this.filterContracts();
    },
    handleClassFilterClickOutside(event) {
      if (this.classFilterOpen && this.$refs.classFilterDropdown && !this.$refs.classFilterDropdown.contains(event.target)) {
        const button = event.target.closest('button');
        if (!button || button.textContent.indexOf('Filter') === -1 && button.textContent.indexOf('ausgewählt') === -1 && button.textContent.indexOf('Alle') === -1) {
          this.classFilterOpen = false;
        }
      }
    },
    toggleSort(key) {
      if (this.sort_by === key) {
        this.sort_order = this.sort_order === 'asc' ? 'desc' : 'asc';
      } else {
        this.sort_by = key;
        this.sort_order = 'asc';
      }
    },
    getSortIcon(key) {
      if (this.sort_by !== key) return 'sort';
      return this.sort_order === 'asc' ? 'sort-up' : 'sort-down';
    },
  },
  computed: {
    uniqueClasses() {
      const classes = new Set();
      this.contracts.forEach(contract => {
        if (contract.class && contract.class.trim()) {
          classes.add(contract.class);
        }
      });
      return Array.from(classes).sort();
    },
    visibilityKey() {
      return 'attendance_visibility';
    },
    visibleCount() {
      return Object.values(this.visible).filter(Boolean).length;
    },
    filteredColumns() {
      if (!this.columnFilter) return this.columns;
      const filter = this.columnFilter.toLowerCase();
      return this.columns.filter(col =>
        col.label.toLowerCase().includes(filter) ||
        col.key.toLowerCase().includes(filter)
      );
    },
    baseOrigin() {
      try {
        const envUrl = process.env.VUE_APP_INTERNAL_URL
        if (envUrl) {
          return new URL(envUrl).origin
        }
      } catch (e) {}
      return new URL(window.location.href).origin
    },
    sortedContracts() {
      const sorted = [...this.filteredContracts];
      
      // First apply user-selected column sorting
      sorted.sort((a, b) => {
        let aValue, bValue;
        
        // Get the value based on the sort_by column
        if (this.sort_by === 'firstname') {
          aValue = a.firstname || '';
          bValue = b.firstname || '';
        } else if (this.sort_by === 'lastname') {
          aValue = a.lastname || '';
          bValue = b.lastname || '';
        } else if (this.sort_by === 'class') {
          aValue = a.class || '';
          bValue = b.class || '';
        } else if (this.sort_by === 'expected') {
          aValue = a.attendance.expected ? 1 : 0;
          bValue = b.attendance.expected ? 1 : 0;
        } else if (this.sort_by === 'plannedEnd') {
          aValue = a.attendance.plannedEnd || '';
          bValue = b.attendance.plannedEnd || '';
        } else if (this.sort_by === 'pickup') {
          aValue = a.pickup ? 1 : 0;
          bValue = b.pickup ? 1 : 0;
        } else if (this.sort_by === 'started') {
          aValue = a.attendance.started ? 1 : 0;
          bValue = b.attendance.started ? 1 : 0;
        } else if (this.sort_by === 'ended') {
          aValue = a.attendance.ended ? 1 : 0;
          bValue = b.attendance.ended ? 1 : 0;
        } else if (this.sort_by === 'excused') {
          aValue = a.attendance.excused ? 1 : 0;
          bValue = b.attendance.excused ? 1 : 0;
        } else if (this.sort_by === 'sick') {
          aValue = a.attendance.sick ? 1 : 0;
          bValue = b.attendance.sick ? 1 : 0;
        } else if (this.sort_by === 'comment') {
          aValue = a.attendance.comment || '';
          bValue = b.attendance.comment || '';
        } else {
          return 0;
        }
        
        // Compare values
        if (typeof aValue === 'string') {
          const comparison = aValue.localeCompare(bValue, 'de');
          return this.sort_order === 'asc' ? comparison : -comparison;
        } else {
          const comparison = aValue - bValue;
          return this.sort_order === 'asc' ? comparison : -comparison;
        }
      });
      
      // Then apply attendance priority logic as secondary sort for equal items
      return sorted.sort((a, b) => {
        const aExpectedNotStarted = a.attendance.expected && !a.attendance.started && !a.attendance.sick && !a.attendance.excused;
        const bExpectedNotStarted = b.attendance.expected && !b.attendance.started && !b.attendance.sick && !b.attendance.excused;
        const aStartedNotEnded = a.attendance.started && !a.attendance.ended;
        const bStartedNotEnded = b.attendance.started && !b.attendance.ended;

        // Expected but not started (highest priority)
        if (aExpectedNotStarted && !bExpectedNotStarted) return -1;
        if (!aExpectedNotStarted && bExpectedNotStarted) return 1;

        // Started but not ended (second priority) - sort by plannedEnd
        if (aStartedNotEnded && bStartedNotEnded) {
          const aTime = a.attendance.plannedEnd || '23:59';
          const bTime = b.attendance.plannedEnd || '23:59';
          return aTime.localeCompare(bTime);
        }

        if (aStartedNotEnded && !bStartedNotEnded) return -1;
        if (!aStartedNotEnded && bStartedNotEnded) return 1;

        return 0; // Keep original order for equal items
      });
    }
  },
  mounted() {
    // Add event listeners for closing column dropdown
    document.addEventListener('click', this.handleClickOutside);
    document.addEventListener('click', this.handleClassFilterClickOutside);
    document.addEventListener('keydown', this.handleEscapeKey);
  },
  beforeDestroy() {
    // Clean up event listeners
    document.removeEventListener('click', this.handleClickOutside);
    document.removeEventListener('click', this.handleClassFilterClickOutside);
    document.removeEventListener('keydown', this.handleEscapeKey);
  },
  created() {
    // Initialize column visibility
    this.initColumnVisibility();

    if (this.$route.query.date) this.filter.date = this.$route.query.date;
    else this.filter.date = new Date().toISOString().slice(0, 10);
    if (this.$route.query.project) {
      this.filter.project = this.$route.query.project;
      this.getAttendance();
    }
    this.updateUrl();
    this.getProjects();
  },
  watch: {
    visible: {
      handler() {
        this.persistVisibility();
      },
      deep: true
    },
    'filter.project': function () {
      this.loadAttendanceDayException();
    },
    'filter.date': function () {
      this.loadAttendanceDayException();
    }
  },
};
</script>